/**
 * Mit der Triggered Viewport Animation lassen sich Elemente beim Eintreten in den Viewport animieren.
 *
 * Das Triggered Viewport Animation Script lässt mit Hilfe der animate.css und Waypoint.js Elemente im Viewport
 * animiert darstellen. Getriggert wird im Viewport. Dazu greift das script auf die Library Waypoint.js zu.
 * @see BASIC__library__waypoint
 * Die Animationen werden über die animate.css ausgeführt.
 * @see https://daneden.github.io/animate.css/
 *
 * @param {string} selector - jQuery Selector in dem die Animation ausgeführt werden soll.
 * @param {string} animationType - Typ der Animation.
 * @param {string} animationOffset - Offset in px oder % ab wann die Animation ausgeführt werden soll. (Bsp.: '90%')
 * Events: document.ready
 **/

function nc_initTriggeredViewportAnimation(selector, animationType, animationOffset) {
    var moduleLogger = LoggerManager.get('triggered-viewport-animation').setPrefix('Selektor: ' + selector);
    moduleLogger.trace('INIT START');
    $(document).ready(function () {
        // Es wird geschaut, welche Elemente animiert werden sollen.
        $(selector).find('.module-content-block').each(function () {
            // Es wird geschaut ob sich das Element im Viewport befindet.
            $(this).waypoint(function () {
                    // Das Element befindet sich im Viewport und die Klassen für die Animation werden gesetzt.
                    $(this.element).addClass('animated ' + animationType);
                },
                // Alle Funktionen erst ausführen, wenn der Viewport Offset erreicht wurde.
                {offset: animationOffset});
        });
    });
    moduleLogger.info('INIT ENDE');
}